import { Button, Skeleton, Stack } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import CreationImage from "./CreationImage";

export default function CreationDetailSelector(props) {
  const {
    item,
    selected,
    onClick,
    placeholder,
    loading,
    disableBlur,
    height,
    imageProps,
  } = props;

  if (placeholder) {
    return (
      <Stack direction="row" spacing={2}>
        {["hooded-reaper-tattoo-idea", "wolf-tattoo-idea"].map((style, i) => (
          <Button key={style} variant="outlined" disabled sx={{ p: 0 }}>
            {loading ? (
              <Skeleton variant="rectangular" width={105} height={85} />
            ) : (
              <img
                src={`/images/${style}.webp`}
                alt={"Example Tattoo Design"}
                style={{
                  objectFit: "contain",
                  opacity: 0.2,
                  // grayscale and blur
                  filter: "grayscale(100%)",
                  margin: "5px 15px",
                }}
                width={75}
                height={75}
                draggable={false}
              />
            )}
          </Button>
        ))}
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={2}>
      {item.imagePaths.map((imagePath, i) => (
        <Button
          key={imagePath}
          component={onClick ? undefined : Link}
          to={
            onClick
              ? undefined
              : !document.location.href.includes("/styles/")
              ? `?variant=${i}`
              : ""
          }
          onClick={onClick ? () => onClick(i) : undefined}
          variant="outlined"
          color={i === selected ? "inherit" : "info"}
        >
          <CreationImage
            creation={item}
            size="small"
            indexToShow={i}
            lazy={false}
            fixedImageHeight={height || 84}
            showThumbnail
            noBackground
            disableBlur={disableBlur || false}
            {...imageProps}
          />
        </Button>
      ))}
    </Stack>
  );
}
